export default {"src":"/_next/static/media/report.105132b1.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};